// Mock appointment shown in the journal settings: realistic values so the
// row order and the switched-off rows are easy to see.
export const APPOINTMENT_PREVIEW_MOCK = {
  timeRange: '10:00 - 11:30',
  services: ['Стрижка женская', 'Окрашивание корней'],
  phone: '+7 900 123-45-67',
  clientName: 'Иванова Анна Сергеевна',
  tags: [
    {
      label: 'Постоянный клиент',
      value: 0,
      color: '#1677ff',
      backgroundColor: '#e6f4ff',
      // id из src/constants/icons.ts — Tag рисует его через FontAwesome
      icon: 'star',
    },
  ],
  comment: 'Предпочитает мастера Ольгу',
};
